<template>
  <store-log-table :type="1" producty-type="原料"></store-log-table>
</template>

<script>
import StoreLogTable from '@/views/modules/store/components/store-log-table'

export default {
  name: 'detail',
  components: {
    StoreLogTable
  }
}
</script>

<style scoped>

</style>
